<template>
  <!-- ========== topo  ========== -->
  <div>

    <div class="container mt-20">
      <vs-row class="items-center">
        <div class="w-3/12"></div>
        <div class="w-full md:w-6/12  vp-video-wrapper transparent" v-if="video.tipo == 'youtube'">
          <div class="videoWrapper">
            <iframe :src="video.src" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
        </div>

        <div class="w-full md:w-6/12  vp-video-wrapper transparent" v-else>
          <div class="videoWrapper">
            <iframe :src="video.src" frameborder="0" allowfullscreen></iframe>
          </div>
        </div>

      </vs-row>

      <!-- swiper -->
      <p class="text-center mt-5 bg-white azulwdc text-base" >Estamos presentes em todos os lugares, clique e confira:</p>
      <swiper class="bg-white p-12" :options="swiperOption"  v-if="atual.videos">

        <swiper-slide v-for="video in atual.videos">

          <vx-card class="card-aparicao" @click="mudaVideo(video.identificacao, video.tipo)">
            <div slot="no-body">
              <a href="javascript:void(0)">
                <img :src="get_img_api_public(video.imagem)" style="padding: .5rem" alt="content-img" class="responsive rounded-lg"               />
              </a>
            </div>
            <div slot="no-body">
              <h1 class="font-black azulwdc text-base text-center py-2">{{video.titulo}}</h1>
            </div>
          </vx-card>

        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
  import "swiper/dist/css/swiper.min.css";
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  export default {
    name: "Aparicoes",
    props:
      {
        atual: {
          type: Object,
        }
      }

  ,
    components: {
      swiper,
      swiperSlide,

    },
    created() {},

    data() {
      return {
        pronome: "a",
        animation_path: [],
        width: window.innerWidth,
        video: {
          src: "https://www.youtube.com/embed/ufjS1m7Volg",
          tipo: "youtube",
        },
        popupActive: false,
        swiperOption: {
          slidesPerView: 5,
          spaceBetween: 50,

          // init: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 40
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 20
            }
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
      };
    },
    methods: {
      next(step) {
        this.$store.dispatch("integracao/setStep", step).then(() => {
          this.$router.push({
            name: "integracao-" + this.$store.state.integracao.page,
          });
        });
      },
      mudaVideo(ident, tipo) {
        let url = "";
        if (tipo == "youtube") {
          url = `https://www.youtube.com/embed/${ident}`;
        } else if (tipo == "globoplay") {
          url = `https://fast.wistia.com/embed/medias/${ident}/  `;
        } else {
          url = "";
        }

        this.video.src = url;
        this.video.tipo = tipo;
      },
    },
    watch: {
      windowWidth() {
        this.width = window.innerWidth;
      },
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
    },
  };
</script>

<style scoped>

</style>
